import { useState } from 'react';
import { useSyncElementSize } from 'packages/lib/common-ui/sync-area-size/use-sync-element-size';
import { RecoilState } from 'recoil';

/**
 * Requires an ID, which is used as the element id and corresponding
 * recoil atom family key. This allows easy subscription, through that recoil state, of changes to this element's size.
 */
export const SyncAreaSize = ({
  id,
  elementSizeAtomFam,
}: {
  id: string;
  elementSizeAtomFam: (
    param: string
  ) => RecoilState<DOMRectReadOnly | null | undefined>;
}): JSX.Element => {
  const [areaContainer, setAreaContainer] = useState<HTMLDivElement | null>(
    null
  );
  useSyncElementSize(elementSizeAtomFam, areaContainer, true);
  return (
    <div
      id={id}
      ref={(el): void => setAreaContainer(el)}
      style={{
        position: 'absolute',
        height: '100%',
        width: '100%',
        left: 0,
        top: 0,
        zIndex: -1,
      }}
    ></div>
  );
};
